import React from 'react';
import { Box, Chip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Filters } from './HomePage';
import { Author } from '../../common/Rest/Services/AuthorsService';
import { Genre } from '../../common/Rest/Services/GenresService';
import { Publisher } from '../../common/Rest/Services/PublishersService';
import { Tag } from '../../common/Rest/Services/TagsService';

type IdFilterKey = 'authors' | 'genres' | 'publishers' | 'tags';

interface FilterChipsProps {
  appliedFilters: Filters;
  authors: Author[];
  genres: Genre[];
  publishers: Publisher[];
  tags: Tag[];
  seriesLabel?: string;
  onChipDelete: (type: IdFilterKey, id: number) => void;
  onAvailabilityClear: () => void;
  onSeriesClear: () => void;
}

const FilterChips: React.FC<FilterChipsProps> = ({
  appliedFilters,
  authors,
  genres,
  publishers,
  tags,
  seriesLabel,
  onChipDelete,
  onAvailabilityClear,
  onSeriesClear,
}) => {
  return (
    <Box sx={{ mb: 2, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
      {appliedFilters.availability !== 'all' && (
        <Chip
          label={appliedFilters.availability === 'in' ? 'Є в наявності' : 'Немає в наявності'}
          onDelete={onAvailabilityClear}
          deleteIcon={<CloseIcon />}
        />
      )}
      {appliedFilters.authors.map((id) => {
        const author = authors.find((item) => item.id === id);
        if (!author) return null;
        return (
          <Chip
            key={`chip-author-${id}`}
            label={`Автор: ${author.name}`}
            onDelete={() => onChipDelete('authors', id)}
            deleteIcon={<CloseIcon />}
          />
        );
      })}
      {appliedFilters.genres.map((id) => {
        const genre = genres.find((item) => item.id === id);
        return (
          genre && (
            <Chip
              key={`chip-genre-${id}`}
              label={`Жанр: ${genre.name}`}
              onDelete={() => onChipDelete('genres', id)}
              deleteIcon={<CloseIcon />}
            />
          )
        );
      })}
      {appliedFilters.publishers.map((id) => {
        const publisher = publishers.find((item) => item.id === id);
        return (
          publisher && (
            <Chip
              key={`chip-publisher-${id}`}
              label={`Видавництво: ${publisher.name}`}
              onDelete={() => onChipDelete('publishers', id)}
              deleteIcon={<CloseIcon />}
            />
          )
        );
      })}
      {appliedFilters.series.length > 0 && (
        <Chip
          label={`Серія: ${seriesLabel ?? '—'}`}
          onDelete={onSeriesClear}
          deleteIcon={<CloseIcon />}
        />
      )}
      {appliedFilters.tags.map((id) => {
        const tag = tags.find((item) => item.id === id);
        return (
          tag && (
            <Chip
              key={`chip-tag-${id}`}
              label={`#${tag.name}`}
              onDelete={() => onChipDelete('tags', id)}
              deleteIcon={<CloseIcon />}
            />
          )
        );
      })}
    </Box>
  );
};

export default FilterChips;
